<style scoped>
[contenteditable]:focus {
  outline: 0px solid transparent;
}

.tab-sheet {
  font-size: 10px;
  border-top: 0.5px solid #ccc;
  border-right: 0.5px solid #ccc;
  width: 100%;
  cursor: pointer;
}

.tab-sheet.active {
  border-top: 0;
}

.tab-sheet .text {
  padding: 5px 20px 5px 20px;
}

.bottom-nav {
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 0;
  float: left;
  width: 100%;
  background-color: #fff;
}

.bottom-nav div {
  display: block;
  float: left;
  width: auto;
  cursor: pointer;
}

.spread-sheet {
  margin-bottom: 30px;
}

.active {
  color: #78CB5B;
}

.inactive {
  color: #fff000;
}

.fa.fa-circle:before {
  content: "\25C9";
  /*color: #000;*/
}

th {
  text-align: center;
}

td:nth-child(1) {
  text-align: center;
}

td:nth-child(3) {
  text-align: center;
}

td:nth-child(2) {
  padding-left: 40px;
}

.event-active {
  font-weight: bold;
  color: #78CB5B;
  text-transform: uppercase;
  letter-spacing: 1.2px;
}
</style>

<template>
<v-layout class="mb-2" row wrap justify-start align-left text-xs-left>
  <v-flex xs12 sm3 pa-3>
    <form>
      <v-layout class="mb-2" row wrap>
        <v-flex xs12 sm12 pa-1>
          <v-text-field v-model="name" :error-messages="nameErrors" label="Connection Name" required @input="$v.name.$touch()" @blur="$v.name.$touch()" sm3></v-text-field>
        </v-flex>
        <v-flex xs12 sm9 pa-1>
          <v-text-field v-model="name" :error-messages="nameErrors" label="Host" required @input="$v.name.$touch()" @blur="$v.name.$touch()" sm3></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 pa-1>
          <v-text-field v-model="name" :error-messages="nameErrors" label="Port" required @input="$v.name.$touch()" @blur="$v.name.$touch()" sm3></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 pa-1>
          <v-text-field v-model="name" :error-messages="nameErrors" label="Username" required @input="$v.name.$touch()" @blur="$v.name.$touch()" sm3></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 pa-1>
          <v-text-field v-model="name" :error-messages="nameErrors"  type="password" label="Password" required @input="$v.name.$touch()" @blur="$v.name.$touch()" sm3></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 pa-1 align-right text-xs-right>
        <v-btn @click="submit" small color="primary"> Connect </v-btn>
        </v-flex>
      </v-layout>
    </form>
  </v-flex>
  <v-flex xs12 sm9>
    test klja;oo;oe
  </v-flex>
</v-layout>
</template>

<script>
import VueDropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import {
  createNamespacedHelpers
}
from 'vuex'
const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations
} = createNamespacedHelpers('dataSources')

const dataSourceNamespace = createNamespacedHelpers('dataSources');
const chartNamespace = createNamespacedHelpers('charts');
import ApiService from "@/services/api.service";

export default {
  data: function() {
    let params = this.$route.params;
    let url = ApiService.getBaseUrl() + "/files/" + params.projectId + "/uploadFile";
    return {
      display: 'progress',
      message: '',
      dialog: false,
      mergeDialog: false,
      dropOptions: {
        url: url,
        headers: ApiService.getHeader(),
        maxFilesize: 200, // MB
        maxFiles: 10,
        acceptedFiles: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      }
    }
  },
  name: 'charts',
  components: {
    'vue-dropzone': VueDropzone
  },
  computed: {
    ...mapState(['dataSources', 'dataSource', 'relatedSources', 'relatedSourcesFound'])
  },
  methods: {
    ...dataSourceNamespace.mapMutations(['mSetRelatedSources', 'mAdd', 'mSetDataSource', 'mSetName', 'mSetType', 'mDelete', 'mSave', 'mSetProjectId']),
    ...dataSourceNamespace.mapActions(['aGetDataSources', 'aAdd', 'aSetDataSource', 'aInit', 'aUpdate', 'aDelete', 'aMerge']),
    updateName: function(event) {
      this.mSetName(event.target.innerText);
    },
    iMerge: async function() {
      this.message = 'Merging worksheets';
      this.display = "progress";
      this.dialog = true;

      await this.aMerge(this.relatedSources);
      this.dialog = false;
      await this.aInit();


      this.$router.push({
        name: 'boards',
        params: {
          projectId: this.$route.params.projectId
        }
      })

    },
    reload: async function() {
      await this.aInit();
      this.dialog = false;
    },
    vsuccessMultiple(files, response) {
      this.mSetProjectId(this.$route.params.projectId);
      this.aInit();
    },
    async vqueueComplete(file, xhr, formData) {
      this.queueComplete = true;
      this.mSetProjectId(this.$route.params.projectId);
      let dataSources = await this.aGetDataSources();
      this.dialog = false;
      this.mSetRelatedSources(dataSources);
      //  console.log(dataSources);
      //  console.log(this.relatedSources);
      //
      //this.dialog = true;
      //  this.mergeDialog = true;

      if (this.relatedSourcesFound) {
        this.display = "merge";
        this.dialog = true;
        //    console.log("display : " + this.display);

        //  this.mergeDialog = true;
        //  console.log("dialog : " + this.dialog);
        //  console.log("mergeDialog : " + this.mergeDialog);
      } else {
        this.aInit();
      }

      // console.log(formData);
    },
    vfileAdded(file) {
      this.message = "Importing file(s)";
      this.display = "progress";
      this.dialog = true;
      // window.toastr.info('', 'Event : vdropzone-files-added')
    }
  },
  mounted: function() {
    // console.log("mounted");
  },
  beforeCreate: function() {

  }
}
</script>
